import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { TableComponentProps, ErrorItem } from '../types';
import { idCreator } from '../../../../../Project/utils/idCreator';

const columnLables = {
  aum_amount_in_euro: {
    name: 'Total AuM Amount In Euro',
    order: 33
  },
  aum_amount_in_base_currency: {
    name: 'Total AuM amount in base currency',
    order: 34
  },
  base_currency: {
    name: 'AIFM Base currency',
    order: 35
  },
  fx_eur_reference_rate_type: {
    name: 'Base currency / EUR FX reference rate type',
    order: 36
  },
  fx_eur_rate: {
    name: 'Base currency / EUR FX rate',
    type: 'customNumber',
    order: 37
  },

  fx_eur_other_reference_rate_description: {
    name: 'Base currency / EUR FX reference rate description for no ECB rates',
    order: 38
  }
};

export function BaseCurrencyAIF001({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const { rows, columns, onChange } = useTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_BASE_CURRENCY_DESCRIPTION,
    onChangeFund,
    schema: schema.AIFM_BASE_CURRENCY_DESCRIPTION,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_BASE_CURRENCY_DESCRIPTION?.field_names || [],
    columnLables,
    tableName: 'AIFM_BASE_CURRENCY_DESCRIPTION',
    funds,
    isMultiFunds
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_BASE_CURRENCY_DESCRIPTION?.field_names?.length ===
    0;

  const errors: ErrorItem[] | undefined = funds[
    currentDataKey
  ]?.fund_data?.AIFM_BASE_CURRENCY_DESCRIPTION?.find(item => item?.errors?.general)?.errors
    ?.general;

  return (
    <>
      <Errors id="reporttables-base-currency-aif001-errors">
        {isRequiredTable && (
          <li id="reporttables-base-currency-aif001-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map((item: ErrorItem) => (
          <li key={item.msg} id={`reporttables-base-currency-aif001-error-${idCreator(item.msg)}`}>
            {item.msg}
          </li>
        ))}
      </Errors>

      <Table
        id="reporttables-base-currency-aif001-table"
        stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
        handleChanges={onChange}
        columns={columns}
        rows={rows}
      />
    </>
  );
}
